export function translateColumns(columns) {
  if (!columns.isTranslated) {
    columns.forEach(column => {
      if (column.headerName) {
        const translatePrefix = 'tables.';
        if (column.headerName.includes(translatePrefix)) {
          this.$set(column, 'headerName', this.$i18n.t(column.headerName))
          // column.headerName = this.$i18n.t(`${translatePrefix}${column.headerName}`);
        } else {
          this.$set(column, 'headerName', this.$i18n.t(`${translatePrefix}${column.headerName}`))
          // column.headerName = this.$i18n.t(`${translatePrefix}${column.headerName}`);
        }
        if (column.children && column.children.length) {
          column.children.forEach(subColumn => {
            if (subColumn.headerName) {
              if (subColumn.headerName.includes(translatePrefix)) {
                this.$set(subColumn, 'headerName', this.$i18n.t(subColumn.headerName))
                // subColumn.headerName = this.$i18n.t(subColumn.headerName);
              } else {
                this.$set(subColumn, 'headerName', this.$i18n.t(`${translatePrefix}${subColumn.headerName}`))
                // subColumn.headerName = this.$i18n.t(`${translatePrefix}${subColumn.headerName}`);
              }
            }

          });
        }
      }
    });
    columns.isTranslated = true;
  }
  // return columns
}

export const translateColumnsProperly = function (colDefs) {
  if (colDefs) {
    const columns = [...colDefs]
    if (!columns.isTranslated) {
      columns.forEach(column => {
        if (column.headerName) {
          const translatePrefix = 'tables.';
          if (column.headerName.includes(translatePrefix)) {
            // this.$set(column, 'headerName', this.$i18n.t(column.headerName))
            column.headerName = this.$i18n.t(`${column.headerName}`);
          } else {
            // this.$set(column, 'headerName', this.$i18n.t(`${translatePrefix}${column.headerName}`))
            column.headerName = this.$i18n.t(`${translatePrefix}${column.headerName}`);
          }
          if (column.children && column.children.length) {
            column.children.forEach(subColumn => {
              if (subColumn.headerName) {
                if (subColumn.headerName.includes(translatePrefix)) {
                  // this.$set(subColumn, 'headerName', this.$i18n.t(subColumn.headerName))
                  subColumn.headerName = this.$i18n.t(subColumn.headerName);
                } else {
                  // this.$set(subColumn, 'headerName', this.$i18n.t(`${translatePrefix}${subColumn.headerName}`))
                  subColumn.headerName = this.$i18n.t(`${translatePrefix}${subColumn.headerName}`);
                }
              }

            });
          }
        }
      });
      columns.isTranslated = true;
    }
    return columns
  }
}



// WEBPACK FOOTER //
// ./src/helpers/translate-helper.js